import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
import { navLinks } from '../data/site';
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${scrolled || open ? 'border-b border-forest-line/70 bg-forest-deep/95 backdrop-blur' : 'border-b border-transparent'}`} data-id="element-47" data-mp="2wk70qd0akxpf">
      <div className="mx-auto flex max-w-shell items-center justify-between px-5 py-4 sm:px-8" data-id="element-48" data-mp="36cwbf5o0q7jp">
        <Logo data-id="element-49" data-mp="3b8bldmiwnjau" />

        <nav aria-label="Main" className="hidden items-center gap-8 lg:flex" data-id="element-50" data-mp="3fbq5ao9ysjtk">
          {navLinks.map(link => <a key={link.href} href={link.href} className="text-sm text-cream-dim transition-colors hover:text-cream" data-id="element-51" data-mp="2wldwxpm955aa">
              {link.label}
            </a>)}
          <a href="#register" className="rounded-full bg-cream px-5 py-2 text-sm font-semibold text-forest transition hover:bg-white" data-id="element-52" data-mp="2mng9338b1ai7">
            Get your ticket
          </a>
        </nav>

        <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? 'Close menu' : 'Open menu'} className="rounded-md p-2 text-cream transition hover:bg-forest-soft lg:hidden" data-id="element-53" data-mp="3faasrxxas5um">
          {open ? <XIcon size={22} data-id="element-54" data-mp="30lwn7f8hy3ad" /> : <MenuIcon size={22} data-id="element-55" data-mp="30klm5n6fr9my" />}
        </button>
      </div>

      {open && <nav id="mobile-nav" aria-label="Mobile" className="border-t border-forest-line/60 bg-forest-deep px-5 pb-6 pt-2 lg:hidden" data-id="element-56" data-mp="1xqtgnzs1kog">
          <ul className="flex flex-col" data-id="element-57" data-mp="1remeslk344h8">
            {navLinks.map(link => <li key={link.href} data-id="element-58" data-mp="1wd648vxvzyec">
                <a href={link.href} onClick={() => setOpen(false)} className="block border-b border-forest-line/40 py-3 text-cream-dim transition-colors hover:text-cream" data-id="element-59" data-mp="1wc4s0o54x5v1">
                  {link.label}
                </a>
              </li>)}
          </ul>
          <a href="#register" onClick={() => setOpen(false)} className="mt-5 block rounded-full bg-cream px-5 py-3 text-center text-sm font-semibold text-forest" data-id="element-60" data-mp="1coox8ognud10">
            Reserve a seat
          </a>
        </nav>}
    </header>;
}